import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeSyllabus } from '../../../functions/Api';
import { Button } from '@asu/unity-react-core';
import { flushSync } from 'react-dom';

function ActionButtons(props) {
  const navigate = useNavigate();
  //   const [buttonDisabled, setButtonDisabled] = useState(true);
  const hasAnySyllabus = props.selectedClasses.some((cls) => cls.hasSyllabus);

  //   // Improved effect to check if any selected class doesn't have a syllabus
  //   useEffect(() => {
  //     if (props.selectedClasses && props.selectedClasses.length !== 0) {
  //       const hasAnySyllabusless = props.selectedClasses.some(
  //         (cls) => cls.hasSyllabus === false
  //       );
  //       setButtonDisabled(hasAnySyllabusless);
  //     } else {
  //       setButtonDisabled(true);
  //     }
  //   }, [props.selectedClasses]);

  const handleAddSyllabus = useCallback(() => {
    if (props.selectedClasses.length > 0) {
      console.log();
      navigate('/upload', { state: { classes: props.selectedClasses } });
    } else {
      window.alert('Please select at least one class.');
    }
  }, [props.selectedClasses, navigate]);

  const removeSyllabi = useCallback(async () => {
    flushSync(() => {
      props.setRemoving(true);
      props.setShowDialog(true);
    });

    let dialogData = [];
    for (let i = 0; i < props.selectedClasses.length; i++) {
      if (props.selectedClasses[i].hasSyllabus) {
        let result = '';
        try {
          result = await removeSyllabus(
            props.selectedClasses[i].classNumber,
            props.selectedClasses[i].strm
          );
          let updatedSyllabusData = props.selectedClasses;
          updatedSyllabusData[i].hasSyllabus = false;
          props.setSelectedClasses(updatedSyllabusData);
        } catch (error) {
          result = error;
        }
        let dialogArrayData = {
          result: result,
          classNumber: props.selectedClasses[i].classNumber,
        };
        dialogData.push(dialogArrayData);
      }
    }

    flushSync(() => {
      props.setRemovalResults(dialogData);
      props.setRemoving(false);
      props.setShowDialog(false);
    });

    //reload the search
    props.setReload(!props.reload);
  }, [props]);

  const handleDeleteSyllabus = useCallback(() => {
    if (props.selectedClasses.length > 0) {
      if (window.confirm('Are you sure you want to delete?')) {
        removeSyllabi();
      }
    } else {
      window.alert('Please select at least one class.');
    }
  }, [props.selectedClasses, removeSyllabi]);

  return (
    <div className="action-buttons d-flex gap-2">
      <Button
        label="Add syllabus"
        color="maroon"
        onClick={handleAddSyllabus}
        disabled={!props.selectedClasses.length}
      />
      <Button
        label="Delete syllabus"
        onClick={handleDeleteSyllabus}
        disabled={!hasAnySyllabus}
      />
    </div>
  );
}

export default ActionButtons;
